import React, { useEffect, useRef, useState } from "react";
import contentTypes from "./contentTypes.json";
import moment from "moment";
import contentStatus from "./contentStatus.json";
import {
  Form,
  Popup,
  Icon,
  Image,
  Divider,
  List,
  Checkbox,
  Button,
  Dropdown,
  Grid,
  Card,
} from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import _ from "lodash";

const FilterColumns = ({
  column,
  columns,
  addColumn,
  handleNameFilter,
  selectedAccount,
  handleDropdownFilter,
  categoryTreeList,
  categoryList,
  tableFilterQuery,
  routeParams,
  filterState,
  updateFilterState,
  showFilters,
  ...props
}) => {
  const {selectedBaseCategory,selectedType, selectedCategory, selectedStatus,selectedSubCategory, selectedUser,searchText,startDate,endDate,mixRange } = filterState;
  //const [searchText, setSearchText] = useState("");
  //const [selectedType, setSelectedType] = useState(null);
  //const [selectedStatus, setSelectedStatus] = useState(null);
  //const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [baseCategories, setBaseCategories] = useState([]);
  //const [selectedBaseCategory, setSelectedBaseCategory] = useState(null);
  //const [selectedCategory, setSelectedCategory] = useState(null);
  //const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  //const [mixRange, setMixRange] = useState(null);
  const [open, setOpen] = useState(false);
  //const [startDate, setStartDate] = useState("");
  //const [endDate, setEndDate] = useState("");
  const [updatedMixRange, setUpdatedMixRange] = useState(null);
  const [updatedOpen, setUpdatedOpen] = useState(false);
  const [updatedStartDate, setUpdatedStartDate] = useState("");
  const [updatedEndDate, setUpdatedEndDate] = useState("");
  useEffect(() => {
    if (
      selectedAccount &&
      selectedAccount.users &&
      selectedAccount.users.length !== 0
    ) {
      let user = [];
      for (let i = 0; i < selectedAccount.users.length; i++) {
        let ia = selectedAccount.users[i];
        user.push({
          value: ia.id._id,
          text: ia.id.firstName + " " + ia.id.lastName,
          content: (
            <span style={{ display: "flex", alignItems: "center" }}>
              <Image
                key={i}
                avatar
                className="w_24 h_24 scaleDown"
                src={ia.id.profilePic}
              />
              {ia.id.firstName} {ia.id.lastName}
            </span>
          ),
        });
      }
      user = user.sort((a, b) => a.text.localeCompare(b.text))
      user.unshift({
        value: "",
        text: "Select",
      })
      setUsers(user);
    }
  }, [selectedAccount.users]);


  useEffect(() => {
    // setSearchText("");
    // setSelectedBaseCategory(null);
    // setSelectedCategory(null);
    // setSelectedStatus(null);
    // setSelectedSubCategory(null);
    // setSelectedUser(null);
    // setSelectedType(null);
    setOpen(false);
    // setStartDate("");
    // setEndDate("");
    // setMixRange("");
  }, [routeParams,props.treeNodeSelected]);

  useEffect(() => {
    if (routeParams.status) {
        const hasFilters = tableFilterQuery.$and && tableFilterQuery.$and.length > 0;
        if (!hasFilters) {  
            updateFilterState("selectedType", null);
            updateFilterState("searchText", null);
            updateFilterState("selectedBaseCategory", null);
            updateFilterState("selectedCategory", null);
            updateFilterState("selectedSubCategory", null);
            updateFilterState("selectedUser", null);
            updateFilterState("selectedStatus", null);
            updateFilterState("startDate", null);
            updateFilterState("endDate", null);
            updateFilterState("mixRange", null);
        }  
    }
}, [routeParams.status, tableFilterQuery]);  


  useEffect(() => {
    let data = { ...tableFilterQuery };
    let baseId = "";
    let catId = "";
    let subId = "";
    if (data && data.$and) {
      _.map(data.$and, (k) => {
        if (k.baseCategory) {
          baseId = k.baseCategory;
        }
        if (k.category) {
          catId = k.category;
        }
        if (k.subCategory) {
          subId = k.subCategory;
        }
      });
    }
    // Knowledge Bank
    let basecategory = [...categoryTreeList];
    basecategory = basecategory.filter((bc) =>
      categoryList.some((cL) => cL._id === bc._id)
    );
    // Category
    let category = [];
    if (baseId !== "") {
      const filteredCategory = basecategory && basecategory.filter((f) => f._id === baseId)
      if(filteredCategory && filteredCategory.length > 0 && filteredCategory[0].nodes){
        category = filteredCategory[0].nodes
      }

    } else if (baseId === "") {
      let setNodes = [];
      _.map(basecategory, (k) => {
        return k.nodes && setNodes.push(k.nodes);
      });
      category = setNodes.flat();
      setNodes = [];
    }
    // subcategory
    let subcategory = [];
    if (catId !== "") {
      const filteredCategory = category && category.filter((f) => f._id === catId)
      if(filteredCategory && filteredCategory.length > 0 && filteredCategory[0].nodes){
        subcategory = filteredCategory[0].nodes
      }
    } else if (catId === "") {
      let setNodes = [];
      _.map(category, (k) => {
        return k.nodes && setNodes.push(k.nodes);
      });
      subcategory = setNodes.flat();
    }

    //Disable Conditions for different senario
    //  let allEmpty = baseId === "" && catId === "" && subId === ""
    // let dBase = !allEmpty && ((baseId === "" && catId === "" && subId !== "") || (baseId === "" && catId !== "" && subId === "") || catId !== "" || basecategory && basecategory.length === 0)
    // let dCat = !allEmpty && ((baseId === "" && catId === "" && subId !== "") || subId !== "" || category && category.length === 0);
    // let dSubCat = !allEmpty && ((baseId === "" && catId === "" && subId === "") || (baseId !== "" && catId === "") || subcategory && subcategory.length === 0);

    let baseCategoryArray = basecategory.map((m) => {
      return { text: m.name, value: m._id };
    });
    let select = { text: "Select", value: "" };
    // tableHead[2].disabled = dBase;
    if(baseCategoryArray && baseCategoryArray.length > 0){
      baseCategoryArray = baseCategoryArray.sort((a, b) => a.text.localeCompare(b.text))
      baseCategoryArray.unshift(select);
    }
    let categoryArray =
      category &&
      category.map((m) => {
        return { text: m.name, value: m._id };
      });
    // tableHead[3].disabled = dCat
    if(categoryArray && categoryArray.length > 0){
      categoryArray = categoryArray.sort((a, b) => a.text.localeCompare(b.text))
      categoryArray.unshift(select);
    } 
    let subCategoryArray =
      subcategory &&
      subcategory.map((m) => {
        return { text: m.name, value: m._id };
      });
    if(subCategoryArray && subCategoryArray.length > 0){  
      subCategoryArray = subCategoryArray.sort((a, b) => a.text.localeCompare(b.text))
      subCategoryArray.unshift(select);
    }
    //  tableHead[4].disabled = dSubCat
    //  tableHead[5].keyValue = user;
    //  this.setState({ tableHeader: tableHead });
    setBaseCategories(baseCategoryArray);
    setCategories(categoryArray);
    setSubCategories(subCategoryArray);
  }, [categoryTreeList, categoryList, tableFilterQuery]);

  const handleSearch = (e) => {
    if (!props.contentLoading) {
      //setSearchText(e.target.value);
      updateFilterState("searchText", e.target.value);
      handleNameFilter(column.id, e.target.value);
    }
  };
  const clearDateRange = (e, data) => {
    // setMixRange("");
    // setStartDate("");
    // setEndDate("");
    updateFilterState("mixRange", "");
    updateFilterState("startDate", "");
    updateFilterState("endDate", "");
    handleDropdownFilter(data.headerkey,null);  
  }
  const clearUpdatedDateRange = (e, data) => {
    setUpdatedMixRange("");
    setUpdatedStartDate("");
    setUpdatedEndDate("");
    handleDropdownFilter(data.headerkey,null);
  }
  const handleDropdownChange = (event, data) => {
    handleNameFilter(column.id, data.value);
    if (column.id === "type") { 
      //setSelectedType(data.value);
      updateFilterState("selectedType", data.value);
    } else if (column.id === "status") {
      updateFilterState("selectedStatus", data.value);
    }
  };
  const handleObjDropdown = (event, data) => {
    if (column.id === "authorObj.firstName") {
      handleDropdownFilter("author", data.value);
      //setSelectedUser(data.value);
      updateFilterState("selectedUser", data.value);
    }
    if (column.id === "baseCategory") {
      handleDropdownFilter(column.id, data.value);
      //setSelectedBaseCategory(data.value);
      updateFilterState("selectedBaseCategory", data.value);  
    }
    if (column.id === "category") {
      handleDropdownFilter(column.id, data.value);
      //setSelectedCategory(data.value);
      updateFilterState("selectedCategory", data.value);
    }
    if (column.id === "subCategory") {
      handleDropdownFilter(column.id, data.value);
      //setSelectedSubCategory(data.value);
      updateFilterState("selectedSubCategory",data.value);
    }
  };
  const openPopup = () => {
    setOpen(!open);
  };
  const openUpdatedPopup = () => {
    setUpdatedOpen(!updatedOpen);
  };
  const closeDateFilter = () => {
    setOpen(false);
    // setStartDate("");
    // setEndDate("");
    updateFilterState("startDate", "");
    updateFilterState("endDate", "");
  };
  const closeUpdatedDateFilter = () => {
    setUpdatedOpen(false);
    setUpdatedStartDate("");
    setUpdatedEndDate("");
  };
  const handleChangeDate = (event, { name, value }) => {
    event.stopPropagation();
    if (name === "startDate") {
      //setStartDate(value);
      updateFilterState("startDate", value); 
      if (value.length === 0) {
        //setEndDate("");
        updateFilterState("endDate", "");
      }
    } else if (name === "endDate") {
      //setEndDate(value);
      updateFilterState("endDate", value);
    }
  };
  const handleUpdatedChangeDate = (event, { name, value }) => {
    event.stopPropagation();
    if (name === "startDate") {
      setUpdatedStartDate(value);
      if (value.length === 0) {
        setUpdatedEndDate("");
      }
    } else if (name === "endDate") {
      setUpdatedEndDate(value);
    }
  };
  const applyDateFilter = (event) => {
    event.stopPropagation();
    let mixRange = `${startDate} - ${endDate}`;
    updateFilterState("mixRange", mixRange);
    //setMixRange(mixRange);
    // let dataFilterObj = {
    //     startDate: startDate,
    //     endDate: endDate,
    //     name: column.id,
    //     value: mixRange,
    //     filterby: 'date'
    // }
    if (startDate && endDate) {
      let value = {
        $gte: new Date(moment(startDate, "DD-MM-YYYY").startOf('day')),
        $lte: new Date(moment(endDate, "DD-MM-YYYY").endOf('day')),
      };
      handleDropdownFilter(column.id, value);
      setOpen(false);
    }
  };
  const applyUpdatedDateFilter = (event) => {
    event.stopPropagation();
    let mixRange = `${updatedStartDate} - ${updatedEndDate}`;
    setUpdatedMixRange(mixRange);
    if (updatedStartDate && updatedEndDate) {
      let value = {
        $gte: new Date(moment(updatedStartDate, "DD-MM-YYYY").startOf('day')),
        $lte: new Date(moment(updatedEndDate, "DD-MM-YYYY").endOf('day')),
      };
      handleDropdownFilter(column.id, value);
      setUpdatedOpen(false);
    }
  };
  // const types = [
  //   {
  //     value: "",
  //     text: "Select",
  //   },
  //   ...contentTypes,
  //   console.log(contentTypes)
  // ];
  const types = [
    {
      value: "",
      text: "Select",
    },
    ...contentTypes.map((type) => ({
      value: type.value,
      text: type.text,
      content: (
        <div>
          <Icon name={type.icon} />
          <span>{type.text}</span>
        </div>
      ),
    })),
  ];
  

  const status = [
    {
      value: "",
      text: "Select",
    },
    ...contentStatus,
  ];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {column.id === "name" ? (
        <Form.Input
          className="filter-search"
          style={{ width: "100px" }}
          value={searchText || ""}
          onChange={(e) => handleSearch(e)}
          placeholder={`${column.Header}`}
          icon={"search"}
        />
      ) : null}

      {column.id === "type" ? (
        <Dropdown
          className="tableFilterDropdown"
           style={{ width: "100px" }}
          placeholder={`${column.Header}`}
          fluid
          selection
          options={types}
          value={selectedType}
          onChange={handleDropdownChange}
        />
      ) : null}
      
      {column.id === "status" ? (
        <Dropdown
          className="tableFilterDropdown"
          placeholder={`${column.Header}`}
          fluid
          selection
          options={status}
          value={selectedStatus}
          onChange={handleDropdownChange}
        />
      ) : null}
      {column.id === "authorObj.firstName" ? (
        <Dropdown
          style={{ width: "100px" }}
          className="tableFilterDropdown"
          placeholder={`${column.Header}`}
          fluid
          selection
          options={users}
          value={selectedUser}
          onChange={handleObjDropdown}
        />
      ) : null}
      {column.id === "baseCategory" ? (
        <Dropdown
        style={{ width: "100px" }}
          className="tableFilterDropdown"
          placeholder={`${column.Header}`}
          fluid
          selection
          options={baseCategories}
          value={selectedBaseCategory}
          onChange={handleObjDropdown}
        />
      ) : null}
      {column.id === "category" ? (
        <Dropdown
          style={{ width: "100px" }}
          className="tableFilterDropdown"
          placeholder={`${column.Header}`}
          fluid
          selection
          options={categories}
          value={selectedCategory}
          onChange={handleObjDropdown}
        />
      ) : null}
      {column.id === "subCategory" ? (
        <Dropdown
          style={{ width: "100px" }}
          className="tableFilterDropdown"
          placeholder={`${column.Header}`}
          fluid
          selection
          options={subCategories}
          value={selectedSubCategory}
          onChange={handleObjDropdown}
        />
      ) : null}
      {column.id === "createdAt" ? (
        <Popup
          trigger={
            <Form.Input
              style={{ width: "100px" }}
              placeholder={`Created At`}
              name="date"
              fluid
              value={mixRange}
              onFocus={openPopup}
              className="filter-search"
              icon={mixRange ?
                    mixRange !== '' ?
                        <Icon
                            name='delete'
                            link
                            onClick={clearDateRange}
                            headerkey={column.id}
                        /> :
                        "calendar alternate outline" :
                    "calendar alternate outline"}
            />
          }
          position="bottom right"
          className="pad_0 "
          open={open}
          style={{ zIndex: 99999 }}
        >
          <Popup.Content>
            <Card style={{ width: "530px" }}>
              <Card.Header className="pad_10 ">
                Select Range
                <Icon
                  name="close"
                  onClick={closeDateFilter}
                  className="float-right cursor-pointer"
                />
              </Card.Header>
              <Card.Content>
                <Grid columns="equal">
                  <Grid.Row className="pad_0 ">
                    <Grid.Column className="pad_5 ">
                      <h3 style={{ margin: "0px 0 5px 0" }}>From</h3>
                      <DateInput
                        maxDate={endDate ? endDate :new Date()}
                        name="startDate"
                        placeholder="Start Date"
                        value={startDate}
                        iconPosition="right"
                        animation="none"
                        onChange={handleChangeDate}
                        clearable={true}
                        closable
                        inline
                      />
                    </Grid.Column>
                    <Grid.Column className="pad_5 ">
                      <h3 style={{ margin: "0px 0 5px 0" }}>To</h3>
                      <DateInput
                        maxDate={new Date()}
                        minDate={startDate}
                        name="endDate"
                        placeholder="End Date"
                        value={endDate}
                        iconPosition="right"
                        animation="none"
                        onChange={handleChangeDate}
                        clearable={true}
                        closable
                        initialDate={startDate}
                        inline
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
              <Card.Content extra>
                <Button
                  size="mini"
                  //disabled={startDate.length === 0 || endDate.length === 0}
                  disabled={!startDate || !endDate} 
                  fluid
                  className={
                    // startDate.length === 0 || endDate.length === 0
                    !startDate || !endDate
                      ? "bg-gray"
                      : "bg-blue"
                  }
                  onClick={(e) => applyDateFilter(e)}
                >
                  Apply
                </Button>
              </Card.Content>
            </Card>
          </Popup.Content>
        </Popup>
      ) : null}
      {column.id === "updatedAt" ? (
        <Popup
          trigger={
            <Form.Input
              style={{ width: "100px" }}
              placeholder={`Updated At`}
              name="date"
              fluid
              value={updatedMixRange}
              onFocus={openUpdatedPopup}
              className="filter-search"
              icon={updatedMixRange ?
                updatedMixRange !== '' ?
                    <Icon
                        name='delete'
                        link
                        onClick={clearUpdatedDateRange}
                        headerkey={column.id}
                    /> :
                    "calendar alternate outline" :
                "calendar alternate outline"}
            />
          }
          position="bottom right"
          className="pad_0 "
          open={updatedOpen}
          style={{ zIndex: 99999 }}
        >
          <Popup.Content>
            <Card style={{ width: "530px" }}>
              <Card.Header className="pad_10 ">
                Select Range
                <Icon
                  name="close"
                  onClick={closeUpdatedDateFilter}
                  className="float-right cursor-pointer"
                />
              </Card.Header>
              <Card.Content>
                <Grid columns="equal">
                  <Grid.Row className="pad_0 ">
                    <Grid.Column className="pad_5 ">
                      <h3 style={{ margin: "0px 0 5px 0" }}>From</h3>
                      <DateInput
                        maxDate={updatedEndDate ? updatedEndDate :new Date()}
                        name="startDate"
                        placeholder="Start Date"
                        value={updatedStartDate}
                        iconPosition="right"
                        animation="none"
                        onChange={handleUpdatedChangeDate}
                        clearable={true}
                        closable
                        inline
                      />
                    </Grid.Column>
                    <Grid.Column className="pad_5 ">
                      <h3 style={{ margin: "0px 0 5px 0" }}>To</h3>
                      <DateInput
                        maxDate={new Date()}
                        minDate={updatedStartDate}
                        name="endDate"
                        placeholder="End Date"
                        value={updatedEndDate}
                        iconPosition="right"
                        animation="none"
                        onChange={handleUpdatedChangeDate}
                        clearable={true}
                        closable
                        initialDate={updatedStartDate}
                        inline
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
              <Card.Content extra>
                <Button
                  size="mini"
                  disabled={updatedStartDate.length === 0 || updatedEndDate.length === 0}
                  fluid
                  className={
                    updatedStartDate.length === 0 || updatedEndDate.length === 0
                      ? "bg-gray"
                      : "bg-blue"
                  }
                  onClick={(e) => applyUpdatedDateFilter(e)}
                >
                  Apply
                </Button>
              </Card.Content>
            </Card>
          </Popup.Content>
        </Popup>
      ) : null}
      {column.id === "actions" ? (
        <Popup
          on="click"
          trigger={<Icon className="float-right table-add-btn custom-settings-icon" />}
          position="bottom right"
          className="pad_0"
          style={{
            display: "block",
            overflow: "auto",
            maxHeight: "200px",
            background: "white",
          }}
        >
          <Popup.Content>
            <List divided verticalAlign="middle">
              <List.Item className="pad_10">
                <List.Content as="h3">Add Column</List.Content>
              </List.Item>
            </List>
            <Divider className="mar_0" />
            <List divided verticalAlign="middle">
              {columns &&
                columns
                  .filter((filtr, i) => {
                    return filtr.accessor !== "actions";
                  })
                  .map((listItems, i) => {
                    return (
                      <List.Item key={i} className="pad_10">
                        <List.Content>
                          <Checkbox
                            key={i}
                            name={listItems.Header}
                            label={listItems.Header}
                            checked={!listItems.hidden}
                            onChange={(e, data) => addColumn(e, i, listItems)}
                          />
                        </List.Content>
                      </List.Item>
                    );
                  })}
            </List>
          </Popup.Content>
        </Popup>
      ) : null}
    </div>
  );
};
export default FilterColumns;
